import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

export default function Description({ text, className }) {
  return text ? <p className={`basic-pod-description ${className}`}>{text}</p> : null;
}

Description.propTypes = {
  text: PropTypes.string,
};
